import { Flex, Text } from '@radix-ui/themes';
import { inputErrorColor, InputErrorType } from 'enums/form';
import { RX } from 'enums/radix';
import { Stringish } from 'lib/enums/utilities';

export const FormHint = (props: {
  hint: Stringish;
  error: InputErrorType;
  // don't show errors unless the input has been touched (or form submission has been attempted)
  touched: boolean;
}) => {
  return (
    <Flex mt="1" gap="1" justify="between">
      <Text size="1" color={RX.CLR.NEUTRAL} truncate>
        {props.hint}
      </Text>

      <Text size="1" color={inputErrorColor(props.error)} truncate>
        {!props.touched || props.error === InputErrorType.None
          ? undefined
          : props.error}
      </Text>
    </Flex>
  );
};
